import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';


import { AuthenticationProvider } from '../authentication/authentication';
import { take, mergeMap } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs';
import { CoreProvider } from '../core/core.service';
import { FuelcardsProvider } from './fuel-cards';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class FuelCardResolver implements Resolve<any> {
    cardsList: any;
    assetsList: any;
    data: any;
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authenticationService.currentUserData()) {
            return this.fuelCardService.getFuelCards().pipe(
                take(1),
                mergeMap(data => {
                    const list: any = data;
                    if (list && list.items.length) {
                        return of(data);
                    } else {
                        this.coreService.presentToastWithOptions(this.translate.instant('MSG18'), 'primary');
                        this.coreService.addClassToBlankMenu('Tank- und Servicekarten');
                        this.router.navigate(['/dashboard']);
                        if (this.router.url === '/dashboard') {
                            this.coreService.hideLoader();
                        }
                        return EMPTY;
                    }
                })
            );
        }
    }

    constructor(private authenticationService: AuthenticationProvider,
                private fuelCardService: FuelcardsProvider,
                private coreService: CoreProvider,
                private translate: TranslateService,
                private router: Router) { }
}
